module.exports = __webpack_public_path__ + "img/bg_1440_0_1015.0ff4e082.jpg";